<mat-sidenav-container>
  <mat-sidenav class="sidenav" position="start" mode="side" [opened]="sidenavOpen" #sidenav>
    <app-nav-brand [class]="settings.colorClasses.brand" />
    <app-nav-left [class]="settings.colorClasses.navigation" />
  </mat-sidenav>

  <div class="sidenav-container flex-col">
    <app-nav-header [sidenav]="sidenav" [class]="settings.colorClasses.header" />
    <main class="main-container" #scrollContainer>
      <h1 class="cdk-visually-hidden">Registrul Medicilor</h1>
      <router-outlet (activate)="onActivate($event, scrollContainer)" />
      @if (isLoading()) {
        <app-nav-loading />
      }
    </main>
    <app-nav-footer />
  </div>
</mat-sidenav-container>